export enum TipoProducto {
  ESTANDAR = 'estandar',
  IMPRESION_3D = 'impresion_3d',
  TE = 'te',
}

export const TIPO_PRODUCTO_LABELS: Record<TipoProducto, string> = {
  [TipoProducto.ESTANDAR]: 'Estándar',
  [TipoProducto.IMPRESION_3D]: 'Impresión 3D',
  [TipoProducto.TE]: 'Té',
};
